export default "__VITE_ASSET__DXLON6m1__"